import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import './style.scss'

const QuickAddButton = ({
  label, onClick,
}) => (
  <div
    className="small-add-button__blue"
    onClick={() => onClick()}
  >
    <FontAwesomeIcon icon={faCirclePlus} />
        &nbsp;
    {label}
  </div>
);

QuickAddButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
};

export default QuickAddButton;
